


















import Vue from 'vue'

export default Vue.extend({
  props: {
    value:[String, Number],
    disablePlaceHolder: {
      type: Boolean,
      default:false,
    },
    options: {
      type: Array,
    },
    placeholder:{
      type:String,
      default:''
    }

  },
})
